import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import { useClintMediaQuery } from '@/utils/hooks/useClintMediaQuery';
import {
  EDUCATION_MAP,
  EDUCATION_NONE,
  WORK_EXPERIENCE_MAP,
  WORK_EXPERIENCE_NONE,
} from '@/constants/job-title';
import { JobTitleContext } from '@/context/create-context';
import SvgHelp from './SvgHelp';

const BarYAxisLabel = (props: { chartData: Record<string, unknown>[] }) => {
  const { chartData } = props;
  const { displayName } = React.useContext(JobTitleContext);
  const isMobile = useClintMediaQuery();

  return (
    <div className="flex flex-col text-sm text-web-grey-600 w-14 shrink-0 pb-7">
      {chartData.map((item: any, index) => {
        const label = item['label'];
        if (
          label === WORK_EXPERIENCE_MAP[WORK_EXPERIENCE_NONE] ||
          label === EDUCATION_MAP[EDUCATION_NONE]
        ) {
          return (
            <div
              key={index}
              className="whitespace-nowrap h-10 leading-10 flex items-center z-1"
            >
              <span className="mr-1">{label}</span>
              {!isMobile && (
                <Tooltip
                  className="hidden tablet:block"
                  title={
                    <p className="text-sm">
                      指对
                      {label === EDUCATION_MAP[EDUCATION_NONE]
                        ? '学历'
                        : '工作经验年限'}
                      没有明确要求{displayName}的平均薪资区间
                    </p>
                  }
                  disableTouchListener={true}
                  placement="bottom-start"
                  PopperProps={{
                    sx: {
                      '.MuiTooltip-tooltip': {
                        background: 'rgba(0, 0, 0, 0.7)',
                        borderRadius: '4px',
                        maxWidth: 'fit-content',
                        padding: '8px 20px',
                        marginTop: '4px !important',
                      },
                    },
                  }}
                >
                  <i className="cursor-pointer">
                    <SvgHelp />
                  </i>
                </Tooltip>
              )}
            </div>
          );
        }
        return (
          <div key={index} className="h-10 leading-10">
            {label}
          </div>
        );
      })}
    </div>
  );
};

export default BarYAxisLabel;
